import { useEffect, useState } from "react";
import api from "../api";

export default function HardwareEmployee() {
  const [hardware, setHardware] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/hardware/my") // assigned only (backend filtered)
      .then((res) => setHardware(res.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div
      style={{
        padding: 28,
        minHeight: "100vh",
        background: "radial-gradient(circle at top, #f8faff, #eef2ff)",
      }}
    >
      {/* HEADER */}
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: "#0f172a" }}>
          My Assigned Hardware
        </h2>
      </div>

      {/* LOADING */}
      {loading && (
        <div style={{ padding: 20, color: "#64748b" }}>Loading hardware...</div>
      )}

      {/* EMPTY */}
      {!loading && hardware.length === 0 && (
        <div
          style={{
            background: "#ffffff",
            padding: 22,
            borderRadius: 14,
            color: "#64748b",
            fontWeight: 600,
          }}
        >
          No hardware assigned
        </div>
      )}

      {/* HARDWARE CARDS */}
      {!loading && hardware.length > 0 && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
            gap: 22,
          }}
        >
          {hardware.map((h) => (
            <div
              key={h._id}
              style={{
                background: "#ffffff",
                borderRadius: 18,
                boxShadow: "0 18px 40px rgba(15,23,42,0.12)",
                overflow: "hidden",
              }}
            >
              {/* CARD HEADER */}
              <div
                style={{
                  background: "linear-gradient(135deg, #16a34a, #4ade80)",
                  padding: "14px 18px",
                  color: "#ffffff",
                }}
              >
                <div style={{ fontSize: 22, fontWeight: 800 }}>{h.type}</div>
                <div style={{ fontSize: 18, fontWeight: 600, opacity: 0.95 }}>
                  {h.productBrand}
                </div>
              </div>

              {/* CARD BODY */}
              <div style={{ padding: 18 }}>
                <InfoRow label="PC Name" value={h.pcName} />
                <InfoRow label="IP Address" value={h.ipAddress} />
                <InfoRow label="Location" value={h.location} />
                <InfoRow
                  label="Connection Type"
                  value={h.connectionType || "—"}
                />
                <InfoRow
                  label="Assigned On"
                  value={
                    h.assignedAt
                      ? new Date(h.assignedAt).toLocaleDateString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : h.updatedAt
                        ? new Date(h.updatedAt).toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : "—"
                  }
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ================= INLINE ROW COMPONENT ================= */
function InfoRow({ label, value }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "7px 0",
        fontSize: 14,
        borderBottom: "1px dashed #e5e7eb",
      }}
    >
      <span style={{ color: "#64748b" }}>{label}</span>
      <strong style={{ color: "#0f172a", marginLeft: 12 }}>
        {value || "—"}
      </strong>
    </div>
  );
}
